// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    overflow: hidden;
}

.no-padding {
    padding: 0px !important;
}

.sidebar-wrapper {
    width: 200px;
    min-width: 200px;
    flex-shrink: 0;
}

@media (min-width: 1600px) {
    .sidebar-wrapper {
        width: 220px;
        min-width: 220px;
    }
}

@media (min-width: 1920px) {
    .sidebar-wrapper {
        width: 250px;
        min-width: 250px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/app.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI;QACI,YAAY;QACZ,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,gBAAgB;IACpB;AACJ","sourcesContent":["body {\r\n    overflow: hidden;\r\n}\r\n\r\n.no-padding {\r\n    padding: 0px !important;\r\n}\r\n\r\n.sidebar-wrapper {\r\n    width: 200px;\r\n    min-width: 200px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n@media (min-width: 1600px) {\r\n    .sidebar-wrapper {\r\n        width: 220px;\r\n        min-width: 220px;\r\n    }\r\n}\r\n\r\n@media (min-width: 1920px) {\r\n    .sidebar-wrapper {\r\n        width: 250px;\r\n        min-width: 250px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
